import {
  DownloadSimpleIcon,
  EyeIcon,
  PencilSimpleIcon,
  TrashIcon,
} from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { RowActions } from "../list";

interface Props {
  onView?: () => void;
  onEdit?: () => void;
  onDownload?: () => void;
  onDelete?: () => void;
}

export function InvoiceActionsMenu({ onView, onEdit, onDownload, onDelete }: Props) {
  const { t } = useTranslation("invoice");

  return (
    <RowActions
      items={[
        {
          key: "view",
          intent: "view",
          icon: <EyeIcon size={17} />,
          label: t("tooltip.details"),
          onClick: () => onView?.(),
          hidden: !onView,
        },
        {
          key: "edit",
          intent: "edit",
          icon: <PencilSimpleIcon size={17} />,
          label: t("tooltip.edit"),
          onClick: () => onEdit?.(),
          hidden: !onEdit,
        },
        {
          key: "pdf",
          intent: "pdf",
          icon: <DownloadSimpleIcon size={17} />,
          label: t("tooltip.pdf"),
          onClick: () => onDownload?.(),
          hidden: !onDownload,
        },
        {
          key: "delete",
          intent: "danger",
          icon: <TrashIcon size={17} />,
          label: t("tooltip.delete", { defaultValue: "Delete" }),
          onClick: () => onDelete?.(),
          hidden: !onDelete,
        },
      ]}
    />
  );
}
